// client/src/constants/mergeTags.js

const MERGE_TAGS = {
  Contact: {
    first_name: {
      name: "First Name",
      value: "#first_name#",
      sample: "John",
    },
    last_name: {
      name: "Last Name",
      value: "#last_name#",
      sample: "Doe",
    },
    full_name: {
      name: "Full Name",
      value: "#full_name#",
      sample: "John Doe",
    },
    email: {
      name: "Email",
      value: "#email#",
      sample: "john@example.com",
    },
    phone: {
      name: "Phone",
      value: "#phone#",
      sample: "(555) 123-4567",
    },
    street_address: {
      name: "Street Address",
      value: "#street_address#",
      sample: "123 Main St",
    },
    city: {
      name: "City",
      value: "#city#",
      sample: "Kansas City",
    },
    state: {
      name: "State",
      value: "#state#",
      sample: "MO",
    },
    zip: {
      name: "ZIP Code",
      value: "#zip#",
      sample: "64111",
    },
  },

  Lead: {
    lead_status: {
      name: "Lead Status",
      value: "#lead_status#",
      sample: "New Lead",
    },
    lead_source: {
      name: "Lead Source",
      value: "#lead_source#",
      sample: "Website",
    },
    lead_id: {
      name: "Lead ID",
      value: "#lead_id#",
      sample: "123",
    },
  },

  Client: {
    client_id: {
      name: "Client ID",
      value: "#client_id#",
      sample: "456",
    },
    dob: {
      name: "Date of Birth",
      value: "#dob#",
      sample: "01/15/1958",
    },
    age: {
      name: "Age",
      value: "#age#",
      sample: "67",
    },
  },

  "Policy / Opportunity": {
    policy_number: {
      name: "Policy Number",
      value: "#policy_number#",
      sample: "ABC123456",
    },
    carrier_name: {
      name: "Carrier Name",
      value: "#carrier_name#",
      sample: "UnitedHealthcare",
    },
    coverage_type: {
      name: "Coverage Type",
      value: "#coverage_type#",
      sample: "Medicare Advantage",
    },
    product_name: {
      name: "Product Name",
      value: "#product_name#",
      sample: "Plan G",
    },
    effective_date: {
      name: "Effective Date",
      value: "#effective_date#",
      sample: "01/01/2026",
    },
    premium: {
      name: "Premium",
      value: "#premium#",
      sample: "$125.00",
    },
  },

  Agent: {
    agent_name: {
      name: "Agent Name",
      value: "#agent_name#",
      sample: "Jane Smith",
    },
    agent_email: {
      name: "Agent Email",
      value: "#agent_email#",
      sample: "agent@agentbookcrm.com",
    },
    agent_phone: {
      name: "Agent Phone",
      value: "#agent_phone#",
      sample: "(555) 987-6543",
    },
    agent_company: {
      name: "Agent Company",
      value: "#agent_company#",
      sample: "Starr Insurance KC",
    },
    agent_title: {
      name: "Agent Title",
      value: "#agent_title#",
      sample: "Licensed Agent",
    },
  },

  Subscriber: {
    business_name: {
      name: "Business Name",
      value: "#business_name#",
      sample: "Sunrise Benefits",
    },
    primary_contact_name: {
      name: "Primary Contact Name",
      value: "#primary_contact_name#",
      sample: "Jamie Example",
    },
    subdomain: {
      name: "Subscriber Subdomain",
      value: "#subdomain#",
      sample: "sunrise-benefits",
    },
    full_domain: {
      name: "Subscriber Full Domain",
      value: "#full_domain#",
      sample: "sunrise-benefits.agentbookcrm.com",
    },
    activation_url: {
      name: "Activation URL",
      value: "#activation_url#",
      sample: "https://sunrise-benefits.agentbookcrm.com/activate-account?token=abc123",
    },
  },

  System: {
    today_date: {
      name: "Today's Date",
      value: "#today_date#",
      sample: "01/31/2026",
    },
    current_year: {
      name: "Current Year",
      value: "#current_year#",
      sample: "2026",
    },
    soa_link: {
      name: "Scope of Appointment Link",
      value: "#soa_link#",
      sample: "https://agentbookcrm.com/soa/verify/abc123",
    },
  },
};

export default MERGE_TAGS;